import React from 'react';
import { Modal, Form, Button, Spinner, Alert } from 'react-bootstrap';
import useProntuario from '../../hooks/useProntuario';

export default function ReportProntuario({ id, onHide }) {
  const { data, error, isLoading } = useProntuario(id);
  const medicacoes = data?.atual?.MEDICAMENTOS || '';
  const condutas = data?.atual?.CONDUTA || '';

  return (
    <Modal show onHide={onHide} size="md" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Medicações e Condutas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="text-center py-5">
            <Spinner
              animation="border"
              variant="primary"
              role="status"
              aria-label="Carregando prontuário"
            />
          </div>
        ) : error ? (
          <Alert variant="danger">
            {error?.response?.data?.error || 'Erro ao buscar prontuário!'}
          </Alert>
        ) : (
          <>
            <Form.Group controlId="report-prontuario-medicacoes">
              <Form.Label>Medicações em Uso</Form.Label>
              <Form.Control
                as="textarea"
                rows={Math.max(3, medicacoes.split('\n').length)}
                value={medicacoes}
                readOnly
                aria-label="Medicações em uso"
              />
            </Form.Group>
            <Form.Group controlId="report-prontuario-condutas" className="mt-3">
              <Form.Label>Condutas</Form.Label>
              <Form.Control
                as="textarea"
                rows={Math.max(3, condutas.split('\n').length)}
                value={condutas}
                readOnly
                aria-label="Condutas"
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          aria-label="Fechar medicações e condutas"
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
